import Axios from 'axios'
import moment from 'moment'

export default {
    namespaced: true,
    state: {
        currencies: [],
        exchangeRates: []
    },
    getters: {
        currencies: (state) => {
            return state.currencies;
        },
        currenciesOptions: (state) => {
            const allOpts = state.currencies.map(ccy => ({id: ccy.id, name: ccy.code})) ?? [];
            const czkIndex = allOpts.findIndex(opt => opt.name === 'CZK');
            const czkOpt = allOpts.splice(czkIndex, 1);
            return [ ... czkOpt, ... allOpts ];
        },
        exchangeRates: (state) => {
            return state.exchangeRates;
        },
        exchangeRatesOptions: (state) => {
            return state.exchangeRates.map(er => ({id: er.id, name: er.systemName})) ?? [];
        },
        getValuesForCurrency: (state) => (secondaryCurrency) => {
            let vals = state.exchangeRates.filter(rate => rate.secondaryCurrency == secondaryCurrency);
        return typeof vals[0] == 'undefined' ? [] : vals[0].rates
        },
        getRate: (state) => (primaryCcy, secondaryCcy, date) => {
            if(primaryCcy === secondaryCcy) return 1;
            const vals = state.exchangeRates.filter(rate => (rate.primaryCurrency == primaryCcy && rate.secondaryCurrency == secondaryCcy) ||
                (rate.primaryCurrency == secondaryCcy && rate.secondaryCurrency == primaryCcy));
            if(vals.length > 0) {
                let rateIdx = 0;
                while(rateIdx < vals[0].rates.length && moment(vals[0].rates[rateIdx].date).diff(date, 'days') > 0) {
                    rateIdx++;
                }
                return vals[0].rates[rateIdx].value / 1000;
            } else {

            }
            console.log(vals);
        }
    },
    mutations: {
        addCurrency(state, {currency}) {
            state.currencies.push(currency);
        },
        addBalancesToAccount(state, {account, balances}) {
            state.accounts.filter(acc => acc.id === account.id)[0].balances = balances;
        },
        addExchangeRate(state, {exchangeRate}) {
            state.exchangeRates.push(exchangeRate);
        },
        setRateValues(state, {id, values}) {
            state.exchangeRates.filter(rate => rate.id == id)[0].rates = values.map(rate => ({
                date: new Date(rate.date),
                value: rate.value / rate.units, units: rate.units
            })).sort((a, b) => moment(b.date).diff(a.date, 'days'));
        }
    },
    actions: {
        refreshCurrencies({commit}) {
            return Axios.get("currency/api/v1/currencies?size=10000")
                .then(res => {
                    res.data.forEach(curr => commit("addCurrency", {currency: curr}));
                })
        },
        refreshExchangeRates({commit}) {
            const fillRate = (rate) => {
                return Axios.get(`currency/api/v1/exchange-rates/${rate.id}/values?size=10000`)
                    .then(res => commit("setRateValues", {id: rate.id, values: res.data}));
            }

            return Axios.get("currency/api/v1/exchange-rates?size=10000")
                .then(res => {
                    res.data.forEach(rate => commit("addExchangeRate", {exchangeRate: rate}));
                    return Promise.all(res.data.map(fillRate));
                })
        }
    }
}
